import React from "react";
import { useTranslation } from "react-i18next";
import "./index.css";
import raceImage from "./Road-bike-frame-size.png";
import raceAfbeelding from "./Racefiets-fietsmaat.png";
import mtbAfbeelding from "./Mountainbike-fietsmaat.png";
import mtbImage from "./Mountain-bike-frame-size.png";
import { startBikefit } from "../../../../components/Bikefit/lib/bikefit";
import ReactGA from 'react-ga4';
import {trackBikefitCTA} from "../../../../lib/mixpanelClient";

const BikeFitPromo = ({ price, dark, mtb = false, primary = false }) => {
  const [t, i18n] = useTranslation("bikefitPromo");

  const bikefitClicked = () => {
    ReactGA.event({
      action: "click",
      category: "bikefit_home_start",
      label: `Start bikefit from the home page`,
      value: 0,
    });

    trackBikefitCTA('bikefinder_promo');

    startBikefit();
  };

  let classes = "bikefit-promo pt-3 pb-3";
  classes += dark ? " dark-section" : " light";

  return (
    <div className={classes}>
      <div className="container">
        <div className="row vcenter">
          <div className="col-12 col-sm-4 text-center">
            <div className="bikefit-promo-image-wrapper">
              <img
                className="bikefit-promo-image"
                src={
                  mtb && i18n.language === "nl_NL"
                    ? mtbAfbeelding
                    : mtbImage && i18n.language === "nl_NL"
                      ? raceAfbeelding
                      : raceImage
                }
                alt="bikefit measurements"
              />
            </div>
          </div>
          <div className="col-12 col-sm-8">
            {primary ? (
              <h1>{t("BikefitPromo_Title")}</h1>
            ) : (
              <h2>{t("BikefitPromo_Title")}</h2>
            )}
            <p>{t("BikefitPromo_Description")}</p>
            <p>
              {price
                ? t("BikefitPromo_Description_Cost", { price: price / 100 })
                : ""}
            </p>
            <p className="lead">
              <button
                onClick={bikefitClicked}
                className="btn btn-lg btn-primary float-right"
              >
                {t("BikefitPromo_CTA")}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BikeFitPromo;
